export default "__VITE_ASSET__B3C$nnh7__";